import { inject, Injector, Provider } from '@angular/core';

import { BILLING_RUN_STEPS, BillingRunStep } from '@shared/services/backend/billing-run.port';

/**
 * Invoicing's work in the nightly billing run (kz2 M6; DS D412, D413): its schedules and its
 * reminders, registered with the F3 run as a step.
 *
 * On Firebase the SERVER runs them (`runDueJobs`, `functions/src/invoicing/billing-steps.ts`,
 * ruling Q9) and this step is never asked. Under `mock` the run is the device's, so the step is
 * the device's too. A thin proxy registered at the root: the work loads in its own chunk when a run
 * asks for it (the 7 MB initial budget — M2, M5).
 */
export function provideInvoicingBillingSteps(): Provider[] {
  return [
    {
      provide: BILLING_RUN_STEPS,
      multi: true,
      useFactory: (): BillingRunStep => {
        const injector = inject(Injector);
        return {
          id: 'invoicing',
          run: async (ctx) => (await import('./invoicing-billing.steps')).runInvoicingSteps(injector, ctx),
        };
      },
    },
  ];
}
